import { z } from 'zod';
import { CustomerStatus } from '../../constants/customer-status.js';
import { nonNegativeNumber, optionalPresentUuidString, optionalTrimmedNullableEmail, optionalTrimmedNullableString, optionalUuidString, rejectPhoneContextInjection, } from '../zod-helpers/index.js';
import { CUSTOMER_CONSTRAINTS } from './constraints.js';
export const updateCustomerInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, 'Customer name cannot be empty.')
        .max(CUSTOMER_CONSTRAINTS.name.maxLength)
        .optional(),
    url: z.string().max(CUSTOMER_CONSTRAINTS.url.maxLength).optional().nullable(),
    note: optionalTrimmedNullableString(CUSTOMER_CONSTRAINTS.note.maxLength),
    email: optionalTrimmedNullableEmail(CUSTOMER_CONSTRAINTS.email.maxLength, `Invalid ${CUSTOMER_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: rejectPhoneContextInjection(optionalTrimmedNullableString(CUSTOMER_CONSTRAINTS.phone.maxLength)),
    currencyId: optionalUuidString('Invalid currency selection.').optional().nullable(),
    paymentTermsId: optionalPresentUuidString('Invalid payment terms selection.').optional(),
    shipTermsId: optionalPresentUuidString('Invalid ship terms selection.').optional(),
    creditLimit: nonNegativeNumber(CUSTOMER_CONSTRAINTS.creditLimit.label).optional().nullable(),
    taxExempt: z.boolean().optional().nullable(),
    taxExemptNumber: z
        .string()
        .max(CUSTOMER_CONSTRAINTS.taxExemptNumber.maxLength)
        .optional()
        .nullable(),
    taxRateId: optionalUuidString('Invalid tax rate selection.').optional().nullable(),
    statusId: z.enum(CustomerStatus, 'Invalid customer status.').optional().nullable(),
    number: z
        .string()
        .trim()
        .min(1, `${CUSTOMER_CONSTRAINTS.number.label} cannot be empty.`)
        .max(CUSTOMER_CONSTRAINTS.number.maxLength)
        .optional(),
    deliveryPreferences: optionalTrimmedNullableString(CUSTOMER_CONSTRAINTS.deliveryPreferences.maxLength),
});
//# sourceMappingURL=update-input.js.map